import React, { useEffect } from 'react';
import { FormikProvider, useFormik } from 'formik';
import PropTypes from 'prop-types';
import { ButtonsPanel } from '../ButtonsPanel/ButtonsPanel';
import { stepperInfo } from '../stepperInfo';
import { StepTwoFormFields } from './StepTwoFormFields';
import styles from './index.module.css';
import TrackSectionStickiness from '../../../analytics/TrackSectionStickiness ';

export const StepTwo = ({
  step,
  draft,
  handleSaveAndClose,
  handleSubmit,
  handlePreviousStep,
  platformPreferences,
  rideOptions,
  setFormikValues,
  showSubInformation = true,
  disabledValues,
  quickSchdule = false,
  setStepValid,
}) => {
  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    initialValues:
      draft && draft.step2
        ? {
            ...draft.step2,
            weight: draft.step1?.riderInfo?.weight,
            height: draft.step1?.riderInfo?.height,
          }
        : stepperInfo[1].values,
    validationSchema: stepperInfo[1].schema(),
    onSubmit: handleSubmit,
  });

  const { values, isValid, setValues } = formik;

  useEffect(() => {
    if (values.vehicleType === 'uberAmbulatoryRide') {
      const normalizedValues = {
        ...values,
        hasStairs: false,
        needsCarSeat: false,
        dischargeFromFacility: false,
        needsAdditionalCarSeat: false,
        needsBoosterSeat: false,
        isWheelchairNeeded: null,
        hasMotorizedWheelchair: null,
        weight: null,
        height: null,
      };

      const hasDifferences =
        values.hasStairs !== normalizedValues.hasStairs ||
        values.needsCarSeat !== normalizedValues.needsCarSeat ||
        values.dischargeFromFacility !== normalizedValues.dischargeFromFacility ||
        values.needsAdditionalCarSeat !== normalizedValues.needsAdditionalCarSeat ||
        values.needsBoosterSeat !== normalizedValues.needsBoosterSeat ||
        values.isWheelchairNeeded !== normalizedValues.isWheelchairNeeded ||
        values.hasMotorizedWheelchair !== normalizedValues.hasMotorizedWheelchair ||
        values.weight !== normalizedValues.weight ||
        values.height !== normalizedValues.height;

      if (hasDifferences) {
        setValues(normalizedValues, false);
      }
    }
  }, [values, setValues]);

  useEffect(() => {
    if (setStepValid) {
      setStepValid(formik.isValid);
    }
  }, [formik.isValid, setStepValid]);

  useEffect(() => {
    setFormikValues && setFormikValues(values, isValid, 'step2');
    return;
  }, [values, isValid, setFormikValues]);

  return (
    <>
      <TrackSectionStickiness sectionName="Create Ride Step 2" />
      {showSubInformation && (
        <h2 className={styles.headTitle}>Step 2: Rider Vehicle Needs</h2>
      )}
      <FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit} className={styles.form}>
          <StepTwoFormFields
            values={formik.values}
            quickSchdule={quickSchdule}
            rideOptions={rideOptions || []}
            minTimeFromRideRequestToPickup={
              platformPreferences?.minTimeFromRideRequestToPickup
            }
            disabledValues={disabledValues}
            isUberEnabled={draft?.isUberEnabled}
          />

          {showSubInformation && (
            <ButtonsPanel
              disabled={!formik.isValid}
              step={step}
              handlePreviousStep={handlePreviousStep}
              handleSaveAndClose={handleSaveAndClose}
              handleSubmit={handleSubmit}
            />
          )}
        </form>
      </FormikProvider>
    </>
  );
};

StepTwo.propTypes = {
  step: PropTypes.number,
  draft: PropTypes.object,
  handleSaveAndClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  handlePreviousStep: PropTypes.func,
  rideOptions: PropTypes.array,
};
